import { NextSeo } from 'next-seo';

import placeholder from 'lib/placeholder';

const Head = () => (
  <>
    <NextSeo
      description={placeholder('seo.commercialPartners.description')}
      openGraph={{
        title: placeholder('seo.commercialPartners.title'),
        description: placeholder('seo.commercialPartners.description'),
      }}
      title={placeholder('seo.commercialPartners.title')}
    />
  </>
);

export default Head;
